module.exports = __webpack_public_path__ + "img/catalog-thumbnail.db9930a.jpg";